// Store location - Moto Veloz, Água Branca, Miguel Alves - PI
export const STORE_LAT = -4.3266306;
export const STORE_LNG = -42.5798577;
export const STORE_ADDRESS = "Água Branca, Miguel Alves - PI";
export const STORE_MAPS_URL = "https://maps.app.goo.gl/HCgb6Vay5ESWK6498";
export const STORE_PHONE = "5586998166143";
export const FRETE_POR_KM = 0.30;

// Calculate distance between two coordinates using Haversine formula
export function calcDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // Earth radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
